import { useEffect, useState } from 'react';
import { Dropdown, DropdownChangeEvent } from '../../Common/Imports';
import { ServiceDateType } from '../../Models/Enums';
import { DDModel } from '../../Models/Classes';


interface DDServiceDateTypeProps {
    value?: ServiceDateType;
    onSelect?: (contact: ServiceDateType | undefined) => void;
    onBlur?: () => void;
}

export const DDServiceDateType: React.FC<DDServiceDateTypeProps> = ({ value, onSelect, onBlur }) => {
    const [data] = useState<DDModel<number>[]>([
        { label: "Check-in Date", id: 5, data: 5 },
        { label: "Cancellation Date", id: 6, data: 6 }
    ]);

    const [selectedElem, setSelectedElem] = useState<DDModel<ServiceDateType>>(data.find(d => d.data === value) || data[0]);

    useEffect(() => {
        // Update state when external value changes
        const newSelection = data.find(d => d.data === value);
        if (newSelection) {
            setSelectedElem(newSelection);
        }
    }, [data, value]);

    const handleChange = (e: DropdownChangeEvent) => {
        const _val = e.value as DDModel<ServiceDateType>;
        setSelectedElem(_val);
        if (onSelect) {
            onSelect(_val.data);
        }
    };

    return (
        <Dropdown
            value={selectedElem}
            onChange={handleChange}
            options={data}
            optionLabel="label"
            onBlur={onBlur}  
            itemTemplate={(d) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {d.label}
                </div>
            )}
        />
    );
};

